<template>
  <div id="page">
    <b-container style="margin-top: 1rem;">

      <div class="cardOriGroup">
        <div>
          <input id="ori_h" type="radio" v-model="cardOri" name="cardOriRd" value="0"></input>
          <label for="ori_h">横版</label>
          /
          <input id="ori_v" type="radio" v-model="cardOri" name="cardOriRd" value="1"></input>
          <label for="ori_v">竖版</label>
        </div>
      </div>

      <div>
        <b-row>
          <b-col cols="6" class="mx-auto text-center uploadGroup" @click="selectCardface()">
            <b-img class="mt-2" src="static/hsbank/img_upload.png"></b-img>
            <h6 class="mt-2"><b>点此上传图片</b></h6>
          </b-col>
        </b-row>
      </div>
     <!-- <div>test:{{ test }}</div> -->
      <div style="margin-top: 32px; padding-left: 16px; padding-right: 16px;">
        <h6><b>上传须知</b></h6>
        <div>1.图片最小分辨率为{{pxLimit}}像素，最大为10MB</div>
        <div>2.涉黄、涉暴、涉政等违规图片将无法审核通过</div>
      </div>
      <div v-show="false">
        <form ref="imgUploadForm">
          <input ref="uploadInput" type="file" accept="image/*" @change.prevent.stop="upload">
        </form>
      </div>

      <b-modal ok-only ref="model_error" title="提示" @ok="handleOk" ok-title="确定" centered>
        <p class="my-4">{{errorMsg}}</p>
      </b-modal>
    </b-container>

  </div>
</template>

<script scoped>
  import wx from 'weixin-js-sdk'
  import axios from 'axios'
  var config = require('../../common/config.js')
  export default {
    name: 'SelectCardface_hf',
    data() {
      return {
        bankSerialNumber: '',
        bankCode: '',
        selectParam: '',
        cardOri: 0,
        pxLimit: '1075 * 686',
        imgWlimit: 1075,
        imgHlimit: 686,
        imgSizeLimit: 10 * 1024 * 1024,
        errorMsg: '',
        test:""
      }
    },
    watch: {
      cardOri: function(newval, oldval) {
        console.log('当前版面方向：' + newval, '之前版面方向：' + oldval)
        if (newval == 0) {
          this.imgWlimit = 1075
          this.imgHlimit = 686
          this.pxLimit = '1075 * 686'
        } else if (newval == 1) {
          this.imgWlimit = 686
          this.imgHlimit = 1075
          this.pxLimit = '686 * 1075'
        }
        console.log('imgWlimit' + this.imgWlimit)
        console.log('imgHlimit' + this.imgHlimit)
      }
    },
    methods: {
      upload: function(event) {
        var that = this
        console.log(event)
        let file = event.target.files[0]
        let fileSize = file.size
        console.log(file)
        let url = null
        if (window.createObjectURL != undefined) {
          // basic
          url = window.createObjectURL(file)
        } else if (window.webkitURL != undefined) {
          // webkit or chrome
          url = window.webkitURL.createObjectURL(file)
        } else if (window.URL != undefined) {
          // mozilla(firefox)
          url = window.URL.createObjectURL(file)
        }
        console.log(url)

        if (fileSize > this.imgSizeLimit) {
          that.errorMsg = '图片大小不能超过10MB'
          that.showErrorMsg()
          that.resetUpload()
        } else {
          let image = new Image()
          let w, h
          image.src = url
          image.onload = function() {
            w = image.width // 图片宽度
            h = image.height // 图片高度
            image.onload = null // 避免重复加载

            console.log('图片宽高:' + w + '*' + h)
            console.log('图片大小:' + (fileSize / 1024) + 'KB')
            if (w >= that.imgWlimit && h >= that.imgHlimit) {
              that.toEditCardface(url)
            } else {
              that.errorMsg = '图片像素不符合要求，图片的像素：' + w + '*' + h
              that.showErrorMsg()
              that.resetUpload()
            }
          }
        };
      },

      resetUpload: function() {
        var form = this.$refs.imgUploadForm
        console.log(form)
        form.reset()
      },
      handleOk: function(bvModalEvt) {

      },
      showErrorMsg: function() {
        this.$refs['model_error'].show()
      },
      hideErrorMsg: function() {
        this.$refs['model_error'].hide()
      },
      selectCardface: function() {
        this.resetUpload()
        this.$refs.uploadInput.click()
        // var that = this;
        // wx.chooseImage({
        //   count: 1, // 默认9
        //   sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
        //   sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
        //   success: function(res) {
        //     console.log(res);
        //     var localIds = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
        //     var faceImgPath = localIds[0];
        //     console.log('imgPath:' + faceImgPath);
        //     that.checkImg(faceImgPath);
        //   },
        // });
      },
      checkImg: function(imgPath) {
        let that = this
        wx.getLocalImgData({
          localId: imgPath, // 图片的localID
          success: function(res) {
            var localData = res.localData
            if (localData.indexOf('data:image') != 0) {
              // 判断是否有这样的头部
              localData = 'data:image/jpeg;base64,' + localData
            }
            localData = localData.replace(/\r|\n/g, '').replace('data:image/jgp', 'data:image/jpeg')
            // 第一个替换的是换行符，第二个替换的是图片类型，因为在IOS机上测试时看到它的图片类型时jgp，
            // 这不知道时什么格式的图片，为了兼容其他设备就把它转为jpeg

            let image = new Image()
            let w, h
            image.src = localData
            // 如果有缓存，读缓存
            // if (image.complete) {
            //   w = image.width; // 图片宽度
            //   h = image.height; // 图片高度
            // } else { //否则加载图片

            // }

            image.onload = function() {
              w = image.width // 图片宽度
              h = image.height // 图片高度
              image.onload = null // 避免重复加载
              if (w > that.imgWlimit && h > that.imgHlimit) {
                let imgSize = that.getImgSize(localData)
                console.log('图片宽高:' + w + '*' + h)
                console.log('图片大小:' + (imgSize / 1024) + 'KB')
                if (imgSize > that.imgSizeLimit) {
                  that.errorMsg = '图片大小不能超过10MB'
                  that.showErrorMsg()
                } else {
                  that.toEditCardface(imgPath)
                }
              } else {
                that.errorMsg = '图片像素不符合要求，图片的像素：' + w + '*' + h
                that.showErrorMsg()
              }
            }
          }
        })
      },
      getImgSize: function(imgBase64) {
        // 1.需要计算文件流大小，首先把头部的data:image/png;base64,（注意有逗号）去掉。
        var str = imgBase64.split(',')[1]
        // 2.找到等号，把等号也去掉
        var equalIndex = str.indexOf('=')
        if (str.indexOf('=') > 0) {
          str = str.substring(0, equalIndex)
        }
        // 3.原来的字符流大小，单位为字节
        var strLength = str.length
        // 4.计算后得到的文件流大小，单位为字节
        var fileLength = parseInt(strLength - (strLength / 8) * 2)
        return fileLength
      },
      toEditCardface: function(imgPath) {
        var selectParam = JSON.stringify(this.selectParam)
        this.$router.push({
          name: 'EditCardface_hf',
          params: {
            imagePath: imgPath,
            bankSerialNumber: this.bankSerialNumber,
            bankCode: this.bankCode,
            selectParam: selectParam,
            cardOri: this.cardOri
          }
        })
      },
    },
  mounted: function () {
    // const userId = sessionStorage.getItem('userId');
    //   console.log("userId--->",userId)
    //   if (userId == null) {
    //     this.$router.push({
    //       name: 'ApplyCard_hf',
    //       params: ""
    //     })
    //   }
     this.bankSerialNumber = this.$route.query.bankSerialNumber
      console.log('bankSerialNumber:' + this.bankSerialNumber)
       var selectParam = this.$route.query.selectParam
      console.log('selectParam:' + selectParam)
      if (selectParam !== undefined) {
        this.selectParam = JSON.parse(selectParam)
      }
      this.test = this.$route.query.selectParam
    },
    activated: function() {
      // this.bankSerialNumber = this.$route.query.bankSerialNumber
      // console.log('bankSerialNumber:' + this.bankSerialNumber)
      // this.bankCode = this.$route.query.bankCode
      // console.log('bankCode:' + this.bankCode)
    },
    beforeRouteLeave(to, from, next) {
      console.log('SelectCardface_hs beforeRouteLeave')
      console.log('to', to)
      console.log('from', from)
      if (to.name == 'Home_hf') {
        this.$router.go(0)
      } else if (to.name != 'EditCardface_hf') {
        // 重新上传卡面
        let reupload = this.$store.state.hf.reuploadCount > 0
        if (reupload) {
          this.$store.commit('hf/decreReuploadImg')
        }
        //FIX更改图片后，重新提交用户信息，上传图片出现“订单未找到”的问题
        this.selectParam = "";
      }
      next()
    }
  }
</script>

<style>
  .uploadGroup {
    border: lightgray solid 1px;
    border-radius: 4px;
    border-style: dashed;
  }

  .cardOriGroup {
    display: flex;
    flex-direction: row;
    justify-content: center;
    text-align: center;
    align-items: flex-end;
    height: 64px;
  }

  .cardOriGroup input {
    display: none;
  }

  .cardOriGroup label {
    color: gray;
    line-height: 28px;
    min-width: 20vw;
    min-height: 28px;
    text-align: center;
    border-radius: 4px;
    margin: 8px;
  }

  .cardOriGroup input:checked+label {
    background-size: 21px 21px;
    font-weight: bold;
    color: black;
    margin: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/hefeibank/SelectCardface_hf.vue